import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Layout } from '@uhg-abyss/web/ui/Layout';

// Customer Submission Group	WALGREENS ASO
// Customer Number	0708547
// Customer File Name	WALASOF.U.202408260000.gsf
// File Identifier	1933451
// File Received Date	08/26/2024
// Processing Date	08/26/2024
// Profile Version	229
// Processing Status	COMPLETE
export const FileDetails = ({ fileDetail, isChild }) => {
  return (
    <Card css={{ 'abyss-card-root': { padding: '0' } }}>
      <div
        style={{
          backgroundColor:
            'var(--abyss-colors-web-semantic-color-surface-container-primary)',
          color:
            'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
          fontSize: '18px',
          padding: '24px',
          borderTopLeftRadius: '3px',
          borderTopRightRadius: '3px',
          fontWeight: 'bold',
        }}
      >
        File Details
      </div>
      <div style={{ padding: '16px' }}>
        <Layout.Group
          grow
          css={{
            '.abyss-table-cell': {
              color: '#212223',
              fontWeight: 500,
            },
            '.abyss-table-cell strong': {
              fontWeight: 500,
            },
          }}
        >
          <Table.Container title="">
            <Table.TableBody>
              <Table.Row>
                <Table.Cell>
                  <strong>Customer Submission Group </strong>
                </Table.Cell>
                <Table.Cell>{fileDetail?.[0]?.sbmtGrpName || ''}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <strong>Customer Number</strong>
                </Table.Cell>
                <Table.Cell>{fileDetail?.[0]?.cescustnbr || ''}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <strong>Customer File Name </strong>
                </Table.Cell>
                <Table.Cell>{fileDetail?.[0]?.fileName || ''}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <strong>File Identifier </strong>
                </Table.Cell>
                <Table.Cell>{fileDetail?.[0]?.fileId || ''}</Table.Cell>
              </Table.Row>
            </Table.TableBody>
          </Table.Container>
          <Table.Container title="">
            <Table.TableBody>
              <Table.Row>
                <Table.Cell>
                  <strong>File Received Date</strong>
                </Table.Cell>
                <Table.Cell>
                  {(fileDetail?.[0]?.fileRecvDate || '')?.split(' ')[0]}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <strong>Processing Date </strong>
                </Table.Cell>
                <Table.Cell>
                  {
                    (fileDetail?.[0]?.processingDt || '')
                      .replace(/_/g, ' ')
                      .split(' ')[0]
                  }{' '}
                  {fileDetail?.[0]?.processingDt
                    .replace(/_/g, ' ')
                    .split(' ')[1]
                    .substring(0, 5)}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <strong>Profile Version</strong>
                </Table.Cell>
                <Table.Cell>{fileDetail?.[0]?.prflverNbr || ''}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <strong>Processing Status </strong>
                </Table.Cell>
                <Table.Cell>{fileDetail?.[0]?.fileStatus || ''}</Table.Cell>
              </Table.Row>
            </Table.TableBody>
          </Table.Container>
        </Layout.Group>
      </div>
    </Card>
  );
};
